import { giphyBlue, giphyLightCharcoal, giphyWhite } from '@giphy/js-brand'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useKeyPress } from 'react-use'

const Container = styled.div`
    display: flex;
    height: 36px;
    color: ${giphyWhite};
    font-family: 'nexablack', sans-serif;
`

const Title = styled.div`
    border-bottom: 4px solid ${giphyBlue};
    box-sizing: border-box;
    font-size: 16px;
`
const CloseButton = styled.div`
    display: flex;
    flex: 1;
    border-bottom: 1px solid ${giphyLightCharcoal};
    box-sizing: border-box;
    justify-content: flex-end;
    cursor: pointer;
`
type Props = { title: string; onClose?: () => void }
const Header = ({ title, onClose = () => {} }: Props) => {
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.keyCode === 27)
    useEffect(() => {
        if (isEscPressed) {
            onClose()
        }
    }, [isEscPressed])
    return (
        <Container>
            <Title>{title}</Title>
            <CloseButton onClick={onClose}>
                <div className="ss-delete" />
            </CloseButton>
        </Container>
    )
}

export default Header
